import React,{useState} from 'react'
import { attendanceData, headerprops, notificationstuboxApi } from '../../../utils/DashboardApi/StudentDashboardApi'
import HeaderOfstuDashComp from './subComponents/HeaderOfstuDashComp'
import SidebarOfsDash from './subComponents/SidebarOfsDash'
import {Row,Col,Nav,Tab,Tabs, Button} from 'react-bootstrap'
import Dropdown from 'react-dropdown';
import {BsChevronDown} from 'react-icons/bs'
import Dropdown2 from '../../subComponents/CustomSubComponents/Dropdown2'
import PillSmall from '../../subComponents/CustomSubComponents/PillSmall'
import NotificationboxComp from '../commonSybcomponent/NotificationboxComp'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import TextField from '@mui/material/TextField';
import moment from 'moment';
import MobileInputSubComp from '../../adminDashboard/mobile/sub_components/MobileInputSubComp'
const StuDashAttComp = () => {
    const handleReqCorrection=()=>{

    }
    const Optionroutinetype = [
        'week','Month','Year'
      ];
      const defaultOptionroutinetype = Optionroutinetype[0];
      const [drproutinetype,setdrproutinetype] = useState("")
    
    const dropdownvalueroutinetype=(myval,myid)=>{
        // console.log(e.value)
        setdrproutinetype(myval)
        
      }
      const [startDate,setStartDate] = useState("")
     
      const [endDate,setEndtDate] = useState("")
     
      const optionme = [
        {
            opt:'Select Section'
        },
        {
            opt:'First Semester'
        }
    ]
    const [shownotificationbox,setshownotificationbox] = useState(false)
    
      function funcnotification(){
          
          setshownotificationbox(!shownotificationbox);
        }
        const handleStartDate = (newvaldob) => {
            console.log(newvaldob)
            // setdateofbirthnew(moment(newvaldob).format("YYYY-MM-DD"))
            if (newvaldob != null) {
    
                var dtofbrth = newvaldob.$M + 1;
                var dtdobfinalc = newvaldob.$y + '-' + dtofbrth + '-' + newvaldob.$D;
                setStartDate(moment(dtdobfinalc).format("YYYY-MM-DD"))
                // setdateofbirthnew(newvaldob)
            }
        }
        const handleEndDate = (newvaldob) => {
            console.log(newvaldob)
            // setdateofbirthnew(moment(newvaldob).format("YYYY-MM-DD"))
            if (newvaldob != null) {
    
                var dtofbrth = newvaldob.$M + 1;
                var dtdobfinalc = newvaldob.$y + '-' + dtofbrth + '-' + newvaldob.$D;
                setEndtDate(moment(dtdobfinalc).format("YYYY-MM-DD"))
                // setdateofbirthnew(newvaldob)
            }
        }
        const [type,settype] = useState("")
        const drpfuncalltype = (myval,myid)=>{
            settype(myval)
        }
  return (
    <>
        <div className="stu_dash_mainWrap">
        <SidebarOfsDash activeID="2"/>
        <div className="rightpartcontentwrap">
        <HeaderOfstuDashComp func={funcnotification} heading="Attendance" myprops={headerprops} />
            {
                shownotificationbox == true ?
                <NotificationboxComp api={notificationstuboxApi}/>
                :
                ""
            }
            <div className="tabPane">
            <div className="tabpaneheightadjust tabpanerightattandancetab">
                    <div className="atttabbox">
                    <Row className='firstrow'>
                            <Col className="d-flex align-items-end">
                            
                            <Dropdown2 func={dropdownvalueroutinetype} fontsize="12" fontfamily="'Poppins', sans-serif" myplaceholder="All Semester" options={optionme}/>
                                
                            
                            </Col>
                            <Col className="d-flex align-items-end">
                               <Dropdown2 func={drpfuncalltype} fontsize="12" fontfamily="'Poppins', sans-serif" myplaceholder="All Type" options={optionme}/>
                            </Col>
                            
                            <MobileInputSubComp mt="15px" mb="0px" col="" direct="center" name="">                                 
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        value={startDate}
                                        onChange={(newvaldob) => handleStartDate(newvaldob)}
                                        renderInput={(params) => <TextField {...params} inputProps={{
                                            ...params.inputProps,
                                            placeholder: "Start Date"
                                        }} error={false} />}
                                    />
                            </LocalizationProvider>
                            </MobileInputSubComp>
                            
                            <MobileInputSubComp mt="15px" mb="0px" col="" direct="center" name="">                                 
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        value={endDate}
                                        onChange={(newvaldob) => handleEndDate(newvaldob)}
                                        renderInput={(params) => <TextField {...params} inputProps={{
                                            ...params.inputProps,
                                            placeholder: "End Date"
                                        }} error={false} />}
                                    />
                            </LocalizationProvider>
                            </MobileInputSubComp>
                            <Col className="d-flex align-items-end">
                                <Button className='reqcorrectionbutton' onClick={handleReqCorrection}>Request for correction</Button>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={12}>
                                <div className="buttonview">
                                    <div className="flexwrap">
                                        <div className="totalpresentpill">
                                            <p>Total Present : 00</p>
                                        </div>
                                        <div className="totalpresentpill totalabsentpill">
                                            <p>Total Absent : 00</p>
                                        </div>
                                        <div className="totalpresentpill totallatepill">
                                            <p>Total Late : 00</p>
                                        </div>
                                        <div className="totalpresentpill totalearlyleave">
                                            <p>Total Present this : 00</p>
                                        </div>

                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={12}>
                                <table>
                                    <thead>
                                        <tr>
                                            {
                                                attendanceData.header.map((item,key)=>{
                                                    return (
                                                        <th key={key}>
                                                            {item.headeritem}
                                                            {
                                                                item.img?
                                                                <img src={item.img} alt="" />
                                                                
                                                                :
                                                                ""
                                                            }
                                                        </th>
                                                    )
                                                })
                                            }                                           
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            attendanceData.innerTableData.map((item,key)=>{
                                                return (
                                                    <tr key={key}>
                                                        <td>
                                                            {item.SL}
                                                        </td>
                                                        <td>
                                                            {item.date}
                                                        </td>
                                                        <td>
                                                            {item.schooltime}
                                                        </td>
                                                        <td>
                                                            {item.intime}
                                                        </td>
                                                        <td>
                                                            {item.outtime}
                                                        </td>
                                                        
                                                        
                                                        <td>
                                                            
                                                            {
                                                            item.type=="Present"?
                                                            <PillSmall class={item.type} fontsize="12px" text={item.type} bg="rgba(0, 202, 85, 0.05)" textcolor="rgba(0,202,85, 1)" />
                                                            :
                                                            
                                                            item.type=="Late"?
                                                            <PillSmall class={item.type} fontsize="12px" text={item.type} bg=" rgba(255, 173, 0, 0.05)" textcolor="rgba(255, 173, 0, 1)" />
                                                            :
                                                            item.type=="Early Leave"?
                                                            <PillSmall class="Earlyleave" fontsize="12px" text={item.type} bg="rgba(100, 158, 255, 0.05)" textcolor="rgba(100, 158, 255, 1)" />
                                                            :
                                                            ""    
                                                        }
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                            </Col>
                        </Row>
                    </div>
                </div>
       
            </div>
        </div>
    </div>
    </>
  )
}

export default StuDashAttComp